import { useEffect, useRef } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ModalTaskClass from 'assets/js/classes/ModalTask'
import { stateUpdateFormControl, useFormControlDispatch, useFormControlState } from 'contexts/FormControlContext'
import { stateUpdateTaskModal, useTaskModalDispatch, useTaskModalState } from 'contexts/TaskModalContext'
import { useToastsDispatch, useToastsState } from 'contexts/ToastsContext'
import useStateCallback from 'hooks/useStateCallback'

export default function ClientName({  }) {
  // CONTEXT PARAMS - FORM CONTROL
  const { disabled } = useFormControlState();
  const formControlDispatch = useFormControlDispatch();

  // CONTEXT PARAMS - TOASTS
  const { toasts } = useToastsState();
  const toastsDispatch = useToastsDispatch();

  // CONTEXT PARAMS - TASK MODAL
  const { task } = useTaskModalState();
  const taskModalDispatch = useTaskModalDispatch();

  // STATE PARAMS
  const [name, setName] = useStateCallback('');

  // REFERENCES
  const nameRef = useRef(null);

  useEffect(() => {
    task?.client?.name && setName(task.client.name);
  }, [task?.client?.name]);

  const handleKeyDown = e => {
    ModalTaskClass.handleEscapeKey(e, task?.client?.name, setName);
  }

  const handleSubmit = e => {
    if (! ModalTaskClass.handleEmptySubmit(e, nameRef, task?.client?.name, setName)) {
      ModalTaskClass.handleSubmit(e, nameRef, { task, update: stateUpdateTaskModal, dispatch: taskModalDispatch }, { update: stateUpdateFormControl, dispatch: formControlDispatch }, { toasts, toastsDispatch });
    }
  }

  return (
    <>
      { task?.client
        ? <Form 
            autoComplete="off"
            className="my-1"
            onSubmit={handleSubmit}
          >
            <InputGroup className="pl-2">
              <InputGroup.Text className="bg-white transparentBorder px-1">
                <FontAwesomeIcon icon={['far', 'id-badge']} fixedWidth />
              </InputGroup.Text>
              <Form.Control
                className="transparentBorder rounded pl-1"
                disabled={Boolean(Number(task?.archived)) || disabled}
                name="client.name"
                onBlur={handleSubmit}
                onChange={e => setName(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Client Name..."
                ref={nameRef}
                required
                type="text"
                value={name}
              />
            </InputGroup>
          </Form>
        : <Skeleton height={38} />
      }
    </>
  )
}